module.exports = "\n<img *ngIf=\"!isSelected\"class=\"face-image\" [src]=\"'/assets/images/face/' + (image) + '.svg'\" alt=\"\">\n<img *ngIf=\"isSelected\" class=\"face-image\" [src]=\"'/assets/images/face/' + (image) + '-active.svg'\" alt=\"\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-face/alg-face.component.html
// module id = ./src/app/components/atoms/alg-face/alg-face.component.html
// module chunks = main